import React from "react";
import { MdPersonAddAlt1 } from "react-icons/md";
import "./AssignUser.css";
import { Tooltip } from "../Tooltip";

export function AssignUser({ onClick }) {

  return (
    <div>
    <Tooltip text="Assign User">
      <button onClick={onClick} className="assign-user-button">
        <MdPersonAddAlt1 />
      </button>
    </Tooltip>

</div>
  );
}
